import React, { createContext, useContext, useState } from 'react';

const StepperContext = createContext();

export const StepperProvider = ({ children }) => {
  const [steps, setSteps] = useState([]);
  const [currentStep, setCurrentStep] = useState(0);

  return (
    <StepperContext.Provider
      value={{ steps, setSteps, currentStep, setCurrentStep }}
    >
      {children}
    </StepperContext.Provider>
  );
};

export const useStepper = () => {
  const { steps, setSteps, currentStep, setCurrentStep } =
    useContext(StepperContext);

  const isFirstStep = currentStep === 0;
  const isLastStep = currentStep === steps.length - 1;

  if (!StepperContext) {
    throw new Error('useStepper must be used inside StepperProvider');
  }

  const goToNextStep = () => {
    setCurrentStep(state => (state < steps.length - 1 ? state + 1 : state));
  };

  const goToPrevStep = () => {
    setCurrentStep(state => (state > 0 ? state - 1 : state));
  };

  const getCurrentStepCategory = () => {
    return steps.length ? steps[currentStep].categoryLabel : null;
  };

  return {
    goToNextStep,
    goToPrevStep,
    setSteps,
    steps,
    currentStep,
    isFirstStep,
    isLastStep,
    getCurrentStepCategory,
  };
};
